import { takeEvery, select } from "redux-saga/effects";
import { actions, selectors } from "redux-store";
import {
  DispatchEventAction,
  EventDetails,
  EventTypes,
} from "./events.interfaces";
import { Level } from "models";
import { GameStatus } from "../game/game.interfaces";

export function* eventsSaga() {
  yield takeEvery(actions.dispatchEvent, function* (
    action: DispatchEventAction,
  ) {
    const { eventType, extraData } = action.payload;

    const detail: EventDetails = { quizName: "Puzzle", ...extraData };

    switch (eventType) {
      case EventTypes.QUIZ_VIEW:
        break;
      case EventTypes.QUIZ_START:
        const chosenGame: Level = yield select(selectors.getChosenLevel);
        if (!chosenGame) {
          return;
        }
        detail.quizStepName = chosenGame.name;
        break;
      case EventTypes.QUIZ_STEP:
        break;
      case EventTypes.QUIZ_LINK:
        break;
      case EventTypes.QUIZ_END:
        const gameStatus: GameStatus = yield select(selectors.getGameStatus);
        const remainingTime: number = yield select(selectors.getRemainingTime);
        const totalMoves: number = yield select(selectors.getTotalMoves);

        const freezeTimePowerUsed: boolean = yield select(
          selectors.getFreezeTimePowerUsed,
        );
        const fixTilePowerUsed: boolean = yield select(
          selectors.getFixTilePowerUsed,
        );

        const quizHelps: string[] = [];

        if (freezeTimePowerUsed) {
          quizHelps.push("Time freeze");
        }
        if (fixTilePowerUsed) {
          quizHelps.push("Fix tile");
        }

        detail.quizStepName = "Feedback";
        detail.quizResult = gameStatus === GameStatus.SUCCESS;
        detail.quizHelps = quizHelps;
        detail.quizRemainingTime =
          gameStatus === GameStatus.FAIL ? 0 : remainingTime;
        detail.quizMoves = totalMoves;

        break;
    }

    window.parent.document.dispatchEvent(
      new CustomEvent(eventType, {
        bubbles: true,
        detail,
      }),
    );
  });
}
